<template>
  <div class="schedule-making">
    <div class="dateser">
      <span>查询日期： </span>
      <el-date-picker
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"/>
    </div>
    <div><span class="heading">当前排产状况表</span></div>
    <el-table
        :data="tableCol"
        border
        style="width: 100%">
      <el-table-column fixed type="index" width="70" label="产线名称"/>
      <el-table-column
          show-overflow-tooltip
          label="value1"
          width="100px">
        <template slot-scope="scope">
          <div class="blueint">{{scope.row.value1}}</div>
          <div style="margin: 2px 0;"/>
          <el-input v-model="scope.row.value1" class="redint" placeholder="0"/>
        </template>
      </el-table-column>
      <el-table-column
          show-overflow-tooltip
          label="value2"
          width="100px">
        <template slot-scope="scope">
          <div class="blueint">{{scope.row.value2}}</div>
          <div style="margin: 2px 0;"/>
          <el-input v-model="scope.row.value2" class="redint" placeholder="0"/>
        </template>
      </el-table-column>
    </el-table>
    <div><span class="heading">预排产表</span></div>
    <el-table
        :data="tableData"
        border
        style="width: 100%">
      <el-table-column fixed type="index" width="70" label="产线名称"/>
      <el-table-column fixed prop="dateNum1" width="100" label="value1"/>
      <el-table-column fixed prop="dateNum2" width="100" label="value2"/>
    </el-table>

    <el-tabs type="border-card" style="margin-top: 20px;">
      <el-tab-pane class="heading" label="代办事项表">
        <vm-table
            ref="vmTable1"
            :filter.sync="filter"
            module="basic"
            url="productionPlans/PreScheduleSalesOrder/List">
          <template slot="adSearch">
            <div class="vm-search">
              <vm-search label="客户合同号">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
              <vm-search label="SAP订单号">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
              <vm-search label="出场编号">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
              <vm-search label="客户名称">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
              <vm-search label="原始交期">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
              <vm-search label="订单数量">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
              <vm-search label="级别">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
              <vm-search label="齐套日期-1">
                <el-input v-model.trim="filter.keyWord" clearable/>
              </vm-search>
            </div>
          </template>
          <el-table-column fixed type="index" width="50" label="ITEM"/>
          <el-table-column fixed prop="clientContractNO" align="center" label="客户合同号"/>
          <el-table-column fixed prop="sAPSalesOrderNO" align="center" label="SAP订单号"/>
          <el-table-column prop="salesOrderNO" align="center" label="出场编号"/>
          <el-table-column prop="customerName" align="center" label="客户名称"/>
          <el-table-column prop="parentName" align="center" label="原始交期"/>
          <el-table-column prop="quantity" align="center" label="订单数量"/>
          <el-table-column prop="deliveryType" align="center" label="级别"/>
          <el-table-column prop="productionTime" align="center" label="单位消耗时间"/>
          <el-table-column prop="createDate" align="center" label="剩余消耗时间（分）"/>
          <el-table-column prop="createDate" label="消耗时间选择"/>
          <el-table-column prop="createDate" label="控制柜开工日期">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.createDate"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="齐套日期-1">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.createDate"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" label="备注"/>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="120px">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.row)">保存</el-button>
            </template>
          </el-table-column>
        </vm-table>
      </el-tab-pane>
      <el-tab-pane class="heading" label="已办事项表">
        <vm-table
            ref="vmTable2"
            :filter.sync="filter"
            module="basic"
            url="productionPlans/PreScheduleSalesOrder/List">
          <template slot="adSearch">
            <div class="vm-search">
              <vm-search label="客户合同号">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
              <vm-search label="SAP订单号">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
              <vm-search label="出场编号">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
              <vm-search label="客户名称">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
              <vm-search label="原始交期">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
              <vm-search label="订单数量">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
              <vm-search label="级别">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
              <vm-search label="确定交货期">
                <el-input v-model.trim="filter.keyWord" width="140" clearable/>
              </vm-search>
            </div>
          </template>
          <el-table-column fixed type="index" width="50" label="ITEM"/>
          <el-table-column fixed prop="clientContractNO" align="center" label="客户合同号"/>
          <el-table-column fixed prop="sAPSalesOrderNO" align="center" label="SAP订单号"/>
          <el-table-column prop="salesOrderNO" align="center" label="出场编号"/>
          <el-table-column prop="customerName" align="center" label="客户名称"/>
          <el-table-column prop="parentName" align="center" label="原始交期"/>
          <el-table-column prop="quantity" align="center" label="订单数量"/>
          <el-table-column prop="deliveryType" align="center" label="级别"/>
          <el-table-column prop="productionTime" align="center" label="单位消耗时间"/>
          <el-table-column prop="createDate" align="center" label="剩余消耗时间（分）"/>
          <el-table-column prop="createDate" label="消耗时间选择"/>
          <el-table-column prop="createDate" label="控制柜开工日期">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.createDate"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="齐套日期-1">
            <template slot-scope="scope">
              <el-date-picker
                  v-model="scope.row.createDate"
                  type="date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期"/>
            </template>
          </el-table-column>
          <el-table-column prop="" align="center" label="备注"/>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="120px">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.row)">保存</el-button>
            </template>
          </el-table-column>
        </vm-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>


  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch";
  export default {
    name: "Production",
    components: {VmSearch,VmTable},
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        filter:{
        },
        value1: "",
        value2: "",


        tableData: [{
          contractID: "E/30068364.001",
          sapID: "1564518124",
          outNo: "PC1215445",
          ordNum: "50",
          lineID: "1",
          cusName: "奥的斯机电电梯有限公司",
          orgDate: "2019/07/13",
          unitcsmpTime: "12",
          remainTime: "600",
          csmptimeChoice: "",
          startTime: "",
          finishTime: "",
          csmpTime: "",
          confirmDate: "",
          remark: "",
          workOrd: "",
          workOrdNum: "",
        }],
        tableCol:[
          {
            value1: "",
            value2: "",
          },
          {
            value1: "",
            value2: "",
          },
        ],
        tableColin:[{
                      dataItem: "shijian",
                      dataName: "019/08/08",
                    },{
                      dataItem: "shijian",
                      dataName: "2019/08/09",
                    },{
                      dataItem: "shijian",
                      dataName: "2019/08/10",
                    },{
                      dataItem: "shijian",
                      dataName: "2019/08/11",
                    },{
                      dataItem: "shijian",
                      dataName: "2019/08/12",
                    },{
                      dataItem: "shijian",
                      dataName: "2019/08/13",
                    },{
                      dataItem: "shijian",
                      dataName: "2019/08/14",
                    },{
                      dataItem: "shijian",
                      dataName: "2019/08/15",
                    },
                    {
                      dataItem: "shijian",
                      dataName: "2019/08/16",
                    },
                    {
                      dataItem: "shijian",
                      dataName: "2019/08/17",
                    }],
        inputNum1:"",

      };
    },
    mounted() {
      this.$refs.vmTable1.getList(1);
      this.$refs.vmTable2.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","/payNodes",row.payNodeID).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
